import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Home, Swords, Rocket, Menu as MenuIcon, X, BookOpen, Shield, Trophy,
  Crown, LogOut, HelpCircle, Mail, Award, Brain,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";

const TABS = [
  { to: "/dashboard", label: "Home", icon: Home },
  { to: "/tryouts", label: "Tryout", icon: Swords },
  { to: "/arena", label: "Arena", icon: Swords },
  { to: "/mega", label: "Akbar", icon: Rocket },
];

const MENU_ITEMS = [
  { to: "/adaptive", label: "Latihan Adaptif", icon: Brain },
  { to: "/modules", label: "Modul Belajar", icon: BookOpen },
  { to: "/guilds", label: "Guild", icon: Shield },
  { to: "/leaderboard", label: "Peringkat", icon: Trophy },
  { to: "/testimoni-saya", label: "Testimoni Saya", icon: Award },
  { to: "/pricing", label: "VIP & Token", icon: Crown },
];

const MENU_SECONDARY = [
  { to: "/faq", label: "FAQ", icon: HelpCircle },
  { to: "/contact", label: "Kontak", icon: Mail },
];

export default function BottomNav() {
  const loc = useLocation();
  const nav = useNavigate();
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  const go = (to) => { setOpen(false); nav(to); };
  const doLogout = () => { setOpen(false); logout(); };

  return (
    <>
      {open && (
        <div className="md:hidden fixed inset-0 z-50" data-testid="mobile-menu-sheet">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setOpen(false)} />
          <div className="absolute bottom-0 inset-x-0 bg-su-surface border-t-2 border-su-border rounded-t-3xl p-5 pb-[calc(env(safe-area-inset-bottom)+1rem)] animate-pop">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading font-black text-lg">Menu</h3>
              <button data-testid="mobile-menu-close" onClick={() => setOpen(false)} className="w-9 h-9 grid place-items-center rounded-lg border-2 border-su-border"><X className="w-5 h-5" /></button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {MENU_ITEMS.map((m) => {
                const active = loc.pathname === m.to;
                return (
                  <button key={m.to} data-testid={`mobile-menu-${m.label.toLowerCase().split(" ")[0]}`} onClick={() => go(m.to)}
                    className={`flex items-center gap-3 p-4 rounded-2xl border-2 text-left transition-colors ${active ? "border-su-primary bg-su-primary/10 text-su-primary" : "border-su-border hover:border-su-primary/50"}`}>
                    <m.icon className="w-6 h-6 shrink-0" />
                    <span className="font-heading font-extrabold text-sm">{m.label}</span>
                  </button>
                );
              })}
            </div>
            <div className="flex items-center gap-4 mt-4 pt-4 border-t-2 border-su-border">
              {MENU_SECONDARY.map((m) => (
                <button key={m.to} onClick={() => go(m.to)} className="flex items-center gap-1.5 text-sm font-heading font-bold text-su-muted">
                  <m.icon className="w-4 h-4" /> {m.label}
                </button>
              ))}
              <button data-testid="mobile-menu-logout" onClick={doLogout} className="flex items-center gap-1.5 text-sm font-heading font-bold text-su-danger ml-auto">
                <LogOut className="w-4 h-4" /> Keluar
              </button>
            </div>
          </div>
        </div>
      )}

      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-su-surface border-t-2 border-su-border pb-[env(safe-area-inset-bottom)]">
        <div className="grid grid-cols-5">
          {TABS.map((t) => {
            const active = loc.pathname === t.to;
            const Icon = t.icon;
            return (
              <Link
                key={t.to}
                to={t.to}
                data-testid={`bottomnav-${t.label.toLowerCase()}`}
                className={`flex flex-col items-center gap-0.5 py-2.5 font-heading font-extrabold text-[10px] transition-colors ${
                  active ? "text-su-primary" : "text-su-muted"
                }`}
              >
                <Icon className={`w-6 h-6 ${active ? "scale-110" : ""} transition-transform`} strokeWidth={active ? 2.6 : 2} />
                {t.label}
              </Link>
            );
          })}
          <button
            data-testid="bottomnav-menu"
            onClick={() => setOpen(true)}
            className={`flex flex-col items-center gap-0.5 py-2.5 font-heading font-extrabold text-[10px] transition-colors ${
              ["/modules", "/guilds", "/leaderboard", "/pricing"].includes(loc.pathname) ? "text-su-primary" : "text-su-muted"
            }`}
          >
            <MenuIcon className="w-6 h-6" strokeWidth={2} />
            Menu
          </button>
        </div>
      </nav>
    </>
  );
}
